import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../common/Loader';
import Modal from 'react-bootstrap/Modal';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import {toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { ListManagementCostHead,AddManagementCostHead,GetManagementCostHeadDetail,UpdateManagementCostHead } from '../store/slices/management-cost.js';

const CostHeadList = () => {
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;
  const navigate = useNavigate();


  const [isLoading, setIsLoading] = useState(false);
  const [managementCostHeadList, setManagementCostHeadList] = useState([]);
  const [columns, setcolumns] = useState([
    { header: 'Sr No', field: 'sr_no' },
    { header: 'Head Name', field: 'name' },
    {
      header: 'Actions',
      field: 'actions',
      isAction: true,
      // Provide a function so buttons can vary per-row (eg. disable for profile_id === 0)
      getActionButtons: (row) => {
        if (row?.profile_id === 0 || row?.profile_id === "0") {
          return []; // no edit/delete for global/default records
        }
        return [
          { name: 'Edit', className: 'btn-default' },
          { name: 'Delete', className: 'btn-cancel' },
        ];
      },
    }
  ]);
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add'); // 'add' | 'edit'
  const [modalValue, setModalValue] = useState('');
  const [editingId, setEditingId] = useState(null);

  const dispatch = useDispatch();

  const fetchList = useCallback(() => {
    setIsLoading(true);
    dispatch(ListManagementCostHead({profile_id: id}))
      .then((action) => {
        // action.payload may vary depending on API shape
        const res = action.payload || action;
        const list = res?.data || res?.list || res?.result || res || [];
        setManagementCostHeadList(Array.isArray(list) ? list : (list.data || []));
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [dispatch, id]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);



    

  



  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    // open modal for editing the head name - fetch details from server
    setModalMode('edit');
    const idToEdit = item?.id ?? null;
    setEditingId(idToEdit);
    setIsLoading(true);
    dispatch(GetManagementCostHeadDetail({ id: idToEdit }))
      .then((action) => {
        const res = action.payload || action;
        const data = res?.data || res?.result || res || {};
        const name = data?.head_name || data?.name || data?.party_name || item?.head_name || '';
        setModalValue(name);
        setShowModal(true);
      })
      .catch(() => {
        toast.error('Failed to load details');
      })
      .finally(() => setIsLoading(false));
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveModal = () => {
    if (!modalValue.trim()) {
      toast.error('Please enter a name');
      return;
    }
    if (modalMode === 'add') {
      setIsLoading(true);
      const payload = { profile_id: id, head_name: modalValue.trim() };
      dispatch(AddManagementCostHead(payload))
        .then((action) => {
          const res = action.payload || action;
          // try common response shapes
          const item = res?.data || res?.result || res || null;
          if (item) {
            setManagementCostHeadList((prev) => [item, ...(prev || [])]);
            toast.success('Added successfully');
          } else {
            // fallback: refetch list
            fetchList();
            toast.success('Added successfully');
          }
        })
        .catch(() => {
          toast.error('Failed to add');
        })
        .finally(() => {
          setIsLoading(false);
          setShowModal(false);
        });
    } else {
      setIsLoading(true);
      const payload = { id: editingId, head_name: modalValue.trim() };
      dispatch(UpdateManagementCostHead(payload))
        .then((action) => {
          const res = action.payload || action;
          const updated = res?.data || res?.result || res || null;
          if (updated) {
            setManagementCostHeadList((prev) =>
              (prev || []).map((it) => (it.id === editingId ? updated : it))
            );
            toast.success('Updated successfully');
          } else {
            fetchList();
            toast.success('Updated successfully');
          }
        })
        .catch(() => {
          toast.error('Failed to update');
        })
        .finally(() => {
          setIsLoading(false);
          setShowModal(false);
        });
    }
  };

  const handleDelete = (item) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this head?');
    if (!confirmDelete) return;

    // If the item is a server-backed record you might dispatch a delete action.
    // For now we remove from local state so UI behaves as expected.
    setManagementCostHeadList((prev) => prev.filter((p) => p.id !== item.id));
    toast.success('Deleted successfully');
  };



  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };


  const filtereditemList = managementCostHeadList?.filter(item =>
    (item?.head_name || item?.name || '').toLowerCase().includes(searchQuery?.toLowerCase())
  );

  // Normalize items to include `sr_no` and a `name` property used by the table
  const normalizedList = (filtereditemList || []).map((item, idx) => ({
    ...item,
    sr_no: idx + 1,
    name: item.head_name || item.name || item.party_name || item.credit_note_number || '',
  }));


  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Cost Head</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Registers
</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                    Cost Head List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                 
                  <button
                    className="btn ripple btn-default"
                    onClick={() => {
                      setModalMode('add');
                      setModalValue('');
                      setEditingId(null);
                      setShowModal(true);
                    }}
                  >
                    Add Cost Head
                  </button>
                   <button
                    className="btn ripple btn-cancel me-2"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                 <Table
                    columns={columns}
                    data={normalizedList}
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filtereditemList?.length}
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleSearchChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Modal for add/edit head name (react-bootstrap) */}
          <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
            <Modal.Header closeButton>
              <Modal.Title>{modalMode === 'add' ? 'Add Head Name' : 'Edit Head Name'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>Head Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalValue}
                  onChange={(e) => setModalValue(e.target.value)}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn ripple btn-cancel" onClick={handleCloseModal}>
                Cancel
              </button>
              <button type="button" className="btn ripple btn-default" onClick={handleSaveModal}>
                {modalMode === 'add' ? 'Save' : 'Update'}
              </button>
            </Modal.Footer>
          </Modal>
        </AdminLayout>
  );
};

export default CostHeadList;
